/**
 * @fileoverview POST handler for the "/apps/business/account_fields" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsLegacyCatalogAccountFieldsCacheKeys } from "./constants";
import type { PostLegacyCatalogAccountFieldsProps, LegacyCatalogAccountFieldsResult } from "./types";

export const postLegacyCatalogAccountFields = reactQueryMutationAdapter(
  appsLegacyCatalogAccountFieldsCacheKeys,
  (props: PostLegacyCatalogAccountFieldsProps): Promise<LegacyCatalogAccountFieldsResult> => {
    return fetch("/apps/business/account_fields", "POST", props, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
